import { ApiError } from "./errors";

interface Problem {
  location?: string;
  path?: string;
  message?: string;
}

/**
 * Field messages from a failed save, keyed by request body field: `422 VALIDATION_FAILED` lists them in
 * `details` (API.md §1), and a `409` for a value another record already uses names its `details.field`.
 * Anything else returns {} and the form shows the error's own message instead.
 */
export function fieldErrors(error: unknown): Record<string, string> {
  if (!(error instanceof ApiError)) return {};
  const result: Record<string, string> = {};
  if (error.code === "VALIDATION_FAILED" && Array.isArray(error.details)) {
    for (const problem of error.details as Problem[]) {
      if (problem.location === "body" && problem.path && problem.message && !result[problem.path]) {
        result[problem.path] = problem.message;
      }
    }
  }
  const field = (error.details as { field?: unknown } | undefined)?.field;
  if (error.status === 409 && typeof field === "string") result[field] = error.message;
  return result;
}
